export default "__VITE_ASSET__DYfrYvIq__"